 {
    "common": {
    "thisWeek": "Diese Woche",
    "lastWeek": "Letzte Woche",
    "lastNumberOfDays": "Letzte {numberOfDays} Tage",
    "thisMonth": "Diesen Monat"
    },
    "subAccounts": "Unterkonten",
    "submitFeedback": "Feedback einreichen",
    "createSubAccount": "Unterkonto erstellen",
    "viewScheduleReports": "Geplante Berichte anzeigen",
    "searchSubAccount": "Suche nach Unterkonto",
    "columns": "Spalte",
    "sortBy": "Sortieren nach",
    "selectColumns": "Spalten Auswählen",
    "maxColumns": "Max.. 8 Spalten an einem Datum",
    "applyColumns": "Spalten anwenden",
    "activeUsers": "Aktive Nutzer",
    "appointments": "Termine",
    "contacts": "Kontakte",
    "emails": "Gmail",
    "textMessages": "Textkörper-Nachricht",
    "calls": "Anrufe",
    "submissions": "Einreichungen",
    "reviews": "Bewertungen",
    "sitesCreated": "Seiten erstellt",
    "name": "Name",
    "formSubmissions": "Formulareinreichungen",
    "surveySubmissions": "Umfrageeinreichungen",
    "facebookFormSubmissions": "Einreichungen von Facebook-Formularen",
    "funnels": "Funnel",
    "websites": "Webseiten",
    "forms": "Formulare",
    "surveys": "Umfragen",
    "highestFirst": "Max.. erste",
    "lowestFirst": "Niedrigste zuerst",
    "orderBy": "Sortieren Via",
    "noMoreLocations": "Keine Adresse mehr gefunden",
    "preparingReport": "Wir bereiten Ihren Bericht vor…",
    "preparingReportDesc": "Sie dürfen dieses Fenster nicht schließen oder neu laden, während der Export läuft.",
    "outOf": "Von",
    "subAccountsExported": "Unterkonten exportiert",
    "close": "Schließen",
    "scheduledForDeletion": "Zum Löschen Geplant",
    "readyToSell": "Bereit zum Verkauf",
    "closedWon": "Abgeschlossen (gewonnen)",
    "wpSaleSuccessful": "WordPress Ververkauf war erfolgreich",
    "wpNotSold": "WordPress noch nicht verkaufen",
    "yxtSaleSuccessful": "Yext-Ververkauf war erfolgreich",
    "yxtNotSold": "Yext noch nicht verkaufen",
    "saasSubInactive": "SaaS Abonnement ist Inaktiv",
    "saasSubTrialing": "Das SaaS-Abonnement befindet sich in der Testphase",
    "saasSubActive": "SaaS Abonnement ist Dynamisch",
    "emailRebillingActive": "E-Mail Neuberechnung ist Dynamisch",
    "emailRebillingInactive": "E-Mail Neuberechnung ist Inaktiv",
    "twilioRebillingActive": "Twilio Neuberechnung ist Dynamisch",
    "twilioRebillingInactive": "Twilio Neuberechnung ist Inaktiv",
    "wpRebillingActive": "WhatsApp-Neuberechnung ist aktiv",
    "wpRebillingInactive": "WhatsApp-Neuberechnung ist inaktiv",
    "saasModeActivated": "SaaS -Modus ist Aktiviert",
    "paymentPending": "Die Bezahlung ist ausstehend",
    "saasModeNotActivated": "SaaS Modus ist nicht aktiviert",
    "managedByLCPhone": "Über SM-Telefon verwalten",
    "migrationToLCPhone": "Im Zuge der Umstellung auf SM- Telefon",
    "notManagedByLCPhone": "Nicht verwalten über SM-Telefon",
    "managedByLCEmail": "Über LeadConnector Email Systemverwalten",
    "notMangedByLCEmail": "Nicht über LeadConnector Email Systemverwalten",
    "remainingWalletBalance": "Verbleibendes Wallet-Guthaben dieses SaaS-Standorts",
    "reports": "Reports",
    "switchToSubAccount": "Zu Unterkonto wechseln",
    "manageClient": "Kunden verwalten",
    "subAccountDeletedIfChangedMind": "Dieses Unterkonto wird am {time} gelöscht, falls Sie Ihre Meinung geändert haben",
    "subAccountDeletedInMinute": "Dieses Unterkonto wird innerhalb der nächsten Minute gelöscht",
    "changedMind": "Wenn Sie Ihren Kopf synchronisieren",
    "clickHere": "Klicken Sie hier",
    "subAccountPaused": "Dieses Unterkonto wurde pausiert. Nur die Agentur kann sich anmelden, Ihre Kunden nicht. So setzen Sie dieses Konto fort",
    "subAccountRestricted": "Dieses Unterkonto wurde aufgrund einer ausstehenden Genehmigung pausiert.",
    "subAccountVerificationPending": "Dieses Unterkonto wurde pausiert, da die E-Mail- und Telefonverifizierung durch den Unterkonto-Admin noch aussteht.",
    "subAccountDeclined": "Dieses Unterkonto wurde aufgrund einer abgelehnten Genehmigungsanfrage pausiert. Sie können dieses Unterkonto fortsetzen von ",
    "here": "hier.",
    "reviewAndResume": "um dieses Unterkonto zu überprüfen und fortzusetzen.",
    "incomingCalls": "Eingehende Anrufe",
    "outgoingCalls": "Ausgehende Anrufe",
    "totalTalktime": "Gesamt Gesprächszeit",
    "incomingEmails": "Eingehende Gmail",
    "outgoingEmails": "Ausgehende Gmail",
    "incomingSms": "Eingehende Textkörper-Nachricht",
    "outgoingSms": "Ausgehende Textkörper-Nachricht",
    "contactsCreated": "Gesamtzahl der erstellten Kontakte",
    "appointmentsBooked": "Gesamtzahl gebuchter Termine",
    "totalFormSubmissions": "Gesamt Formulareinsendungen",
    "totalSurveySubmissions": "Gesamte Umfrage-Einsendungen",
    "totalFacebookFormSubmissions": "Gesamte Facebook-Formular-Einsendungen",
    "incomingGMBMessages": "Eingehende GBP-Nachrichten",
    "outgoingGMBMessages": "Ausgehende GBP-Nachrichten",
    "gmbMessages": "GBP-Nachrichten",
    "fbMessages": "Facebook-Nachrichten",
    "incomingFbMessages": "Eingehende Facebook-Nachricht",
    "outgoingFbMessages": "Ausgehende Facebook-Nachricht",
    "igMessages": "Instagram-Nachrichten",
    "incomingIgMessages": "Eingehende Instagram-Nachricht",
    "outgoingIgMessages": "Ausgehende Instagram-Benachrichtigungen",
    "totalReviews": "Gesamt der Bewertungen",
    "positiveReviews": "Positiv Bewertungen",
    "negativeReviews": "Negativ Bewertungen",
    "back": "Zurück",
    "selectDashboards": "Dashboards Auswählen",
    "next": "Nächste",
    "backToSubAccounts": "Zurück zu den Unterkonten",
    "pauseSchedule": "Zeitplan Pause",
    "resumeSchedule": "Zeitplan für die Wiederaufnahme",
    "editSchedule": "Zeitplan bearbeiten",
    "addSchedule": "Zeitplan hinzufügen",
    "selectReportToAdd": "Auswählen Reports zum Einbeziehen in der E-Mail",
    "selectAll": "Auswählen jeder",
    "pauseScheduleConfirm": "Möchten Sie den Bericht Zeitplan wirklich Pause ?",
    "resumeScheduleConfirm": "Möchten Sie den Zeitplan wirklich wieder aufnehmen?",
    "tasks": "Aufgaben",
    "conversations": "Konversationen",
    "users": "Benutzer",
    "dealOverview": "Vertrag Übersicht",
    "confirmAction": "Aktion bestätigen",
    "yes": "Ja",
    "no": "Nein",
    "reportDetails": "Berichtdetails",
    "reportCreatedOn": "Bericht Erstellt An",
    "searchByEmail": "Suchen Sie Via E-Mail",
    "lastActivity": "Letzte Aktivität",
    "noRecords": "Keine Datensätze gefunden",
    "scheduleReport": "Bericht vorausplanen",
    "schedule": "Zeitplan",
    "save": "Speichern",
    "emailSubject": "Betreffzeile",
    "frequency": "Frequenz",
    "daily": "Täglich",
    "weekly": "Wöchentlich",
    "monthly": "Monatlich",
    "nextScheduleDate": "Nächste Zeitplan Datum",
    "startingOn": "Starten von An",
    "timeOfDay": "Datum von Tag",
    "reportsToTimezone": "Der Bericht wird in der Zeitzone des Unterkontos gesendet",
    "selectRecipients": "Empfänger Auswählen",
    "invalidEmail": "Geben Sie eine gültige E-Mail-Adresse ein.",
    "testEmail": "Test E-Mail",
    "selectTestRecipients": "Auswählen Test",
    "setupSubject": "Konfigurieren Sie den Betreff oben, um den Bericht zu Test",
    "sendTest": "Test Upload",
    "scheduleSimilarSchedules": "Einen ähnlichen Bericht für andere Unterkonten planen",
    "accountSummary": "Kontozusammenfassung",
    "scheduleList": "Zeitplan-Liste",
    "subAccountName": "Name des Unterkontos",
    "nextRunDate": "Nächstes Ausführungsdatum",
    "reportSectionsAdded": "Berichtsabschnitte wurden hinzugefügt",
    "status": "Status",
    "scheduleAction": "Aktion einplanen",
    "cancel": "Stornieren",
    "pleaseWait": "Wird geladen …",
    "confirm": "Bestätigen",
    "booked": "Gebucht",
    "confirmed": "Bestätigt",
    "showed": "Erschienen",
    "noShow": "Nicht erschienen",
    "cancelled": "Abgesagt",
    "unread": "Ungelesen",
    "engagement": "Engagement",
    "reaction": "Antwort",
    "deliverySummary": "Zusammenfassung der Zustellung",
    "successfulDelivery": "Erfolgreiche Lieferung",
    "opened": "Geöffnet",
    "clicked": "Geklickt",
    "replied": "Beantwortet",
    "unsubscribed": "Abgemeldet",
    "complained": "Beschwert",
    "failed": "Fehlgeschlagen",
    "bounced": "Bounce",
    "open": "Öffnen",
    "won": "Gewonnen",
    "abandoned": "Abgebrochen",
    "lost": "Verlust",
    "sent": "Gesendet",
    "eject": "Auswerfen",
    "delivered": "Zugestellt",
    "faceBookLeadForm": "Facebook-Lead-Formular",
    "overdue": "Überfällig",
    "reviewsReceived": "Bewertungen Empfangen",
    "formBuilders": "Formular-Builder",
    "switchToSaaS": "Wechsle zu SaaS",
    "numberOfContacts": "Gesamtzahl der Kontakte",
    "numberOfAppointments": "Gesamtzahl der Termine",
    "outreach": "Reichweite",
    "notSubAccountUser": "Kein Benutzer eines Unterkontos",
    "searchSubAccName": "Suche nach dem Namen des Unterkontos",
    "recipients": "Empfänger",
    "scheduleCreated": "Zeitplan für E-Mail-Berichte erstellt für ",
    "scheduleUpdated": "Zeitplan für E-Mail-Berichte aktualisiert für ",
    "scheduleNotCreated": "Zeitplan für E-Mail-Berichte konnte nicht erstellt werden für",
    "scheduleNotUpdated": "Zeitplan für E-Mail-Berichte konnte nicht aktualisiert werden für",
    "total": "Gesamt",
    "inbound": "Eingehende",
    "outbound": "Outbound",
    "totalEmails": "Gesamtzahl der E-Mails",
    "inboundEmails": "Eingehende E-Mails",
    "outboundEmails": "Outbound-E-Mails",
    "totalTextMessages": "Gesamtzahl der Textnachrichten",
    "inboundTextMessages": "Eingehende Textnachrichten",
    "outboundTextMessages": "Ausgehende Textnachrichten",
    "totalCalls": "Anrufe gesamt",
    "inboundCalls": "Eingehende Anrufe",
    "outboundCalls": "Ausgehende Anrufe",
    "faceBookLeadFormSubmissions": "Facebook-Lead-Formulareinreichungen",
    "inboundGMBMessages": "Eingehende GBP-Nachrichten",
    "outboundGMBMessages": "Ausgehende GBP-Nachrichten",
    "totalIgMessages": "Gesamtzahl der Instagram-Nachrichten",
    "inboundIgMessages": "Eingehende Instagram-Nachrichten",
    "outboundIgMessages": "Ausgehende Instagram-Nachrichten",
    "totalfbMessages": "Gesamtzahl der Facebook-Nachrichten",
    "inboundfbMessages": "Eingehende Facebook-Nachrichten",
    "outboundfbMessages": "Ausgehende Facebook-Nachrichten",
    "sitesCreatedFunnels": "Erstellte Seiten – Funnel",
    "sitesCreatedActiveFunnels": "Erstellte Websites – Aktive Funnel",
    "sitesCreatedWebsites": "Erstellte Seiten – Websites",
    "sitesCreatedActiveWebsites": "Erstellte Seiten – Aktive Websites",
    "sitesCreatedForms": "Erstellte Seiten – Formulare",
    "sitesCreatedActiveForms": "Erstellte Seiten – Aktive Formulare",
    "sitesCreatedSurveys": "Erstellte Seiten – Umfragen",
    "sitesCreatedActiveSurveys": "Erstellte Seiten – Aktive Umfragen",
    "googleReviews": "Google-Rezensionen",
    "facebookReviews": "Facebook-Rezensionen",
    "inboundCallDuration": "Dauer des eingehenden Anrufs (Stunden)",
    "outboundCallDuration": "Dauer des ausgehenden Anrufs (Stunden)",
    "pleaseSelect": "Auswählen",
    "subAccountIsDeleted": "Dieses Unterkonto wurde gelöscht",
    "subAccountIsPaused": "Dieses Unterkonto wurde pausiert",
    "success": "Erfolg",
    "error": "Fehler",
    "testEmailSent": "Test E-Mail gesendet",
    "testEmailNotSent": "Test E-Mail konnte nicht gesendet werden",
    "reviewRequest": "Rezensionsanfragen",
    "pendingTransferDescription": "Andere Agenturen haben die Übertragung von Unterkonten zu Ihnen beantragt.",
    "pendingTransferHeading": "Sie haben ausstehende Anträge zur Übertragung von Unterkonten.",
    "subAccountTransfer": "Übertragungen von Unterkonten",
    "manageSubAccTransfer": "Verwalten Sie Ihre Anträge auf die Übertragung von Unterkonten",
    "subAccRequest": "{tabName}-Anfragen für Unterkonto",
    "receive": "Erfolgen",
    "send": "Senden",
    "release": "Version",
    "requests": "{count} Anfragen",
    "subAccLimit": "Nutzungslimit für Unterkonten erreicht.",
    "subAccPlanLimit": "Sie haben 3 von 3 Unterkonten verwendet, die in Ihrem aktuellen Plan erlaubt sind.",
    "upgradeTime": "Es ist Zeit für ein Upgrade!",
    "upgradeHigher": "Bitte führen Sie ein Upgrade auf einen höheren Plan durch, um die Übertragung des Unterkontos zu akzeptieren.",
    "browse": "Pläne durchsuchen",
    "pendingTransferTitle": "Für dieses Unterkonto steht bereits ein Übertragungsantrag aus.",
    "unableTransfer": "Unterkonto kann nicht an diese Agentur übertragen werden.",
    "unableEjectCancel": "Die Anfrage zum Entfernen des Unterkontos kann nicht annulliert werden.",
    "EjectErrorDetails": "Die Anfrage zum Entfernen des Unterkontos kann nicht annulliert werden.",
    "hippaErrorDescription": "Dieses Unterkonto ist HIPAA-konform und kann nicht an eine nicht-HIPAA-konforme Agentur übertragen werden.",
    "pendingTransferErrorDescription": "Annullieren Sie die bestehende Übertragungsanfrage für dieses Unterkonto, bevor Sie eine neue erstellen.",
    "receivingAgency": "Empfangende Agentur",
    "releasingAgency": "Freigabeagentur",
    "noOfContacts": "Gesamtzahl der Kontakte",
    "requestedDate": "Angefordertes Datum",
    "action": "Aktion",
    "cancelTransfer": "Übertragung annullieren",
    "decline": "Ablehnen",
    "cancelTransferRequest": "Übertragungsanfrage für das Unterkonto annullieren?",
    "cancelEjectRequest": "Antrag auf Entfernen des Unterkontos annullieren?",
    "cancelRequestDescription": "Die empfangende Agentur wird diese Übertragungsanfrage nicht mehr sehen, und das Unterkonto {name} wird nicht übertragen.",
    "cancelEjectRequestDescription": "Der ausgewählte Nutzer wird nicht mehr in der Lage sein, eine neue Agentur aus dem Unterkonto {name} zu erstellen.",
    "declineRequest": "Möchten Sie den Antrag auf Übertragung des Unterkontos ablehnen?",
    "declineRequestDescription": "Die Anfrage wird abgelehnt und das Unterkonto {name} wird nicht an Ihre Agentur übertragen.",
    "approveTransfer": "Übertragung des Unterkontos an Ihre Agentur genehmigen?",
    "approveTransferDescription": "{name}-Unterkonto wird an Ihre Agentur übertragen.",
    "transferNow": "Jetzt übertragen",
    "cancelNow": "Jetzt annullieren",
    "transferErrorDetails": "Dieses Unterkonto kann nicht übertragen werden.",
    "cancelRequest": "Anfrage annullieren",
    "received": "Empfangen",
    "approve": "Genehmigen",
    "goBack": "Zurück",
    "done": "Erledigt",
    "subAccountTransferred": "Das Unterkonto wurde übertragen",
    "subAccountTransferDescription": "Obwohl das Unterkonto erfolgreich übertragen wurde, kann es noch 10–15 Minuten dauern, bis Assets wie Benutzer, Rufnummern, Mailgun-Konten und Yext-Einträge am Ziel sichtbar sind.",
    "activeSubscriptionsAlert": "Der Standort hat Dynamisch Abonnement. Bitte Absagen jedes Abonnements Vorher Blinde Weiterleitung den Standort. Liste von dynamischen Abonnements: {subscriptions}",
    "isSaasEnabled": "Für SaaS aktiviert",
    "typeToSearch": "Eintippen zum Suchen",
    "dateAdded": "Hinzugefügtes Datum",
    "emailEngagement": "E-Mail-Interaktionen",
    "emailReaction": "E-Mail-Reaktion",
    "emailDeliverySummary": "Zusammenfassung der E-Mail-Zustellung",
    "facebook": "Facebook",
    "sms": "SMS",
    "instagram": "Instagram",
    "accountSummarySubAccount": "Kontozusammenfassung – {subAccountName}",
    "test": "Test",
    "scheduleExists": "Zeitplan existiert",
    "aToZ": "A - Z",
    "zToA": "Z - A",
    "onlyAdminUsersCanAddNewSubAccounts": "Nur Admin-Benutzer können neue Unterkonten hinzufügen.",
    "locationName": "Standortname",
    "transferCompleted": "Die Transferanfrage für diesen Standort wurde bereits bearbeitet. Bitte aktualisieren Sie die Seite.",
    "unauthorizedTransfer": "Sie sind nicht berechtigt, diese Aktion durchzuführen. Nur Eigentümer der Agentur können diese Aktion ausführen.",
    "bulkLocationTransfer": "Bulk-Übertragung von Unterkonten",
    "singleRequest": "Einzelanfrage",
    "bulkRequest": "Massendatenanfrage",
    "backToLocationTransfer": "Zurück zur Standortübertragung",
    "initiateBulkTransfer": "Bulk-Unterkontoübertragung initiieren",
    "initiateBulkTransferDescription": "Wählen Sie die Unterkonten aus, die Sie übertragen möchten, oder geben Sie deren IDs, durch Kommas getrennt, ein.",
    "subAccountId": "Unterkonto-ID",
    "selectFromList": "Aus Liste auswählen",
    "addManually": "Manuell hinzufügen",
    "accountsSelected": "{count} ausgewählt",
    "selectAllSubAccounts": "Auswählen jeder",
    "removeAll": "Alle entfernen",
    "addManualLocations": "Fügen Sie Standort-IDs, getrennt durch Kommas, hinzu",
    "manualAllLocationIds": "Standort-IDs von dem Unterkonto, das Sie Transfer möchten, Getrennt Via Communities.",
    "enterLocationIds": "Standort-IDs eingeben",
    "selectSubAccounts": "Unterkonten auswählen und an eine bestehende Agentur übertragen",
    "subAccountTransferWarning": "Jeder Unterkonto-Verpasst und Benutzer erhalten Herunterladen.",
    "proceed": "Fortfahren",
    "bulkRequestSubmitted": "Bulk-Übertragungsanfrage wurde eingereicht",
    "bulkRequestSubmittedDescription": "Jedes Unterkonto wird übertragen, sobald die empfangende Agentur den Übertragungsantrag akzeptiert hat. Sie können den Status der Anfrage auf der Seite „{pagename}“ verfolgen (sofern sie teilnahmeberechtigt sind)",
    "bulkTransferRequestFailed": "Bulk-Übertragungsanforderung fehlgeschlagen",
    "errorLocations": "Unterkonten mit Fehler",
    "viewDetails": "Details anzeigen",
    "somethingWrong": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "confirmBulkRequest": "Bulk-Übertragungsanforderung bestätigen?",
    "bulkTransferAccounts": "Bulk-Übertragung von {count} ausgewählten Unterkonten?",
    "confirmDetails": "Bestätigen Sie die Details vor der Übertragung.",
    "transferConsent": "Ich habe Lesen und den oben genannten Rat und die Einwilligung zu jeder der Einschränkungen verstehen.",
    "transferInfo": "Ob ein Unterkonto übertragen werden kann, hängt davon ab, ob die empfangende Agentur es in ihr Konto aufnehmen möchte.",
    "receivingRelNo": "Beziehungsnummer der empfangenden Agentur",
    "enterRelNo": "Beziehungsnummer eingeben",
    "transferConfirmation": "Nach Abschluss dieser Aktion werden die Massedaten Transfer Anfragen an die Empfangen Agentur ({ relNo }) gesendet. Jeder Unterkonto, den Sie ausgewählt haben, wird herunterladen, sobald die Empfangen Agentur es angenommen hat. Bitte beachten Sie, dass diese Aktion für jedes in der Transfer enthaltene Unterkonto nicht rückgängig gemacht werden kann.",
    "confirmPassword": "Bestätigen Sie, Via password unter eingeben",
    "enterPassword": "Passwort eingeben",
    "requestTransfer": "Übertragung beantragen",
    "confirmTransfer": "Übertragung bestätigen",
    "notNow": "Nicht jetzt",
    "invalidRelNo": "Ungültige Beziehungsnummer",
    "invalidPassword": "Ungültiges password.",
    "searchSubAccounts": "Unterkonten suchen",
    "searchSubAccountsId": "Unterkonto-ID suchen",
    "takeAction": "Aktion erforderlich",
    "sub_account_details": "Details des Unterkontos",
    "no_of_contacts": "Gesamtzahl der Kontakte",
    "transfer_status": "Übertragungsstatus",
    "error_info": "Fehlerinfo",
    "bulk_transfer_status": "Status der Bulk-Unterkontenübertragung",
    "pending": "Anhängig",
    "processed": "Verarbeitet",
    "reject_all": "Alle ablehnen",
    "accept_all": "Alle akzeptieren",
    "cancel_all": "Alle annullieren",
    "clearAll": "Alles löschen",
    "refresh": "Aktualisieren",
    "rejected": "Abgelehnt",
    "decline_transfer": "Transfer ablehnen",
    "decline_bulk_transfer": "Bulk-Übertragungsanfrage für Unterkonten ablehnen?",
    "decline_bulk_transfer_description": "Die Anfrage wird abgelehnt und die {length} Unterkonten werden nicht an Ihre Agentur übertragen.",
    "accept_bulk_transfer": "Bulk-Übertragungsanfrage für Unterkonten annehmen?",
    "accept_bulk_transfer_description": "Die Anfrage wird akzeptiert und die {length} Unterkonten werden an Ihre Agentur übertragen.",
    "cancel_bulk_transfer": "Möchten Sie die Bulk-Übertragung annullieren?",
    "cancel_bulk_transfer_description": "Sind Sie sicher, dass Sie diese Bulk-Übertragung von {length} Unterkonten an „{name}“ annullieren möchten?",
    "consent_sub_account_transfer": "Bitte Lesen und Einwilligung zu {link}",
    "sub_account_transfer_guidelines": "Richtlinien für die Übertragung von Unterkonten",
    "valid_rel": "Geben Sie eine gültige Nummer ein",
    "something_went_wrong": "Es ist ein Fehler aufgetreten. Bitte versuchen Sie es erneut.",
    "export": "Exportieren",
    "export_success": "Die von Ihnen angeforderten Daten werden bearbeitet. Sie erhalten eine E-Mail mit den Daten in einem Datum.",
    "export_failed": "Die von Ihnen angeforderten Daten konnten nicht bearbeitet werden. Bitte Erneut versuchen Sie es später.",
    "selectAllError": "Sie können jeweils nur 1.000 Unterkonten auswählen.",
    "max1000": "(Max. 1.000)",
    "subAccountCount": "Anzahl der Unterkonten",
    "whatsapp": "WhatsApp",
    "scheduleBulkPauseConfirm": "Möchten Sie {count} Reports wirklich Pause ?",
    "scheduleBulkResumeConfirm": "Möchten Sie {count} -Berichte wirklich wiederaufnahme?",
    "resume": "Wiederaufnahme",
    "pause": "Pause",
    "resumeSelected": "Wiederaufnahme ausgewählt",
    "pauseSelected": "Pause ausgewählt",
    "bulkActions": "Bulk actions",
    "xReportsSelected": "{count} Berichte ausgewählt",
    "selectAllXReports": "Wählen Sie alle {count} Berichte aus",
    "scheduleStatus": "Zeitplanstatus",
    "scheduleSearchPlaceholder": "Suche nach E-Mail-Adresse oder Standortnamen",
    "subAccountsPerPage": "Unterkonten pro Seite",
    "previous": "Vorherige",
    "scheduleBulkAction": "Bulk-Aktion planen",
    "all": "Alle",
    "active": "Aktiv",
    "paused": "Pausiert",
    "scheduleUpdatedSuccessfully": "Zeitplan erfolgreich aktualisiert",
    "saveChanges": "Änderungen speichern",
    "pauseSchedulesTitle": "Aktiv Geplant-Berichte Pause",
    "pauseSchedulesDescription": "Klicken Sie, um jetzt Aktive Reports Pause .",
    "pauseSchedulesAlert": "Dies wirkt sich nur auf Konten aus, die jetzt Dynamisch sind.",
    "pauseAllSchedulesBtnText": "Alle geplanten Berichte pausieren",
    "autoScheduleTitle": "Automatische Planung für neue Konten",
    "autoScheduleLabel": "Automatisch geplante Berichte erstellen, wenn ein neues Unterkonto hinzugefügt wird.",
    "autoScheduleAlert": "Deaktivieren Sie diese Option, wenn Sie die Konfiguration für Neu Konto manuell konfigurieren möchten.",
    "autoScheduleEnabledForNewAccounts": "Auto-Zeitplan aktiviert für Neu Konto",
    "autoScheduleDisabledForNewAccounts": "Auto-Zeitplan deaktiviert für Neues Konto",
    "deleted": "Gelöscht",
    "locationPaused": "Standort pausiert",
    "scheduleSettingsModalTitle": "Zeitplan Report Einstellungen",
    "selectAllSchedules": "Auswählen jeder Zeitplan",
    "selectScheduleForLocation": "Zeitplan für {location}Auswählen",
    "openSettings": "Einstellungen Öffnen",
    "resumeScheduleForLocation": "Wiederaufnahme Zeitplan für {location}",
    "pauseScheduleForLocation": "Pause {location} {Zeitplan}",
    "actions": "Aktionen",
    "deselectAll": "Deaktivieren Sie jeder",
    "scheduleBulkActionResumeSuccess": "Massedaten-Aktivierung in Gange – Halten Deaktiviert An Neuen Aktivitäten",
    "scheduleBulkActionPauseSuccess": "Berichte werden pausiert – warten Sie, bevor Sie weitere Maßnahmen ergreifen",
    "bulkActionCreationError": "Eine andere Bulk-Aktion erfolgt bereits. Bitte versuchen Sie es in Kürze erneut.",
    "bulkActionInProgress": "Massedaten-Aktion bereits in Gange",
    "scheduledReports": "Geplant Reports",
    "scheduleBulkActionCompleted": "Massedaten Aktion Erledigt erfolgreich",
    "pauseAllSchedulesModalTitle": "Berichte pausieren?",
    "pauseAllSchedulesModalText": "Dadurch werden alle aktiven geplanten Berichte in allen Unterkonten pausiert.",
    "addLocationIdsPlaceholder": "Fügen Sie Standort-IDs hinzu, die Sie übertragen möchten …",
    "helloWorld": {
      "count": "Anzahl ist {count}",
      "editIntro": "Bearbeiten",
      "editAction": "Um HMR zu testen",
      "checkOut": "Kasse",
      "officialStarter": ", der offizielle Vue + Vite-Starter",
      "install": "Installieren",
      "installDescription": "In Ihrer IDE für eine bessere DX",
      "learnMore": "Klicken Sie auf die Vite- und Vue-Logos, um mehr zu erfahren"
    },
    "home": {
      "testMessage": "Guten Tag! Dies ist die Test-Startseite!"
    },
    "reports": {
      "incoming": "Ankommend",
      "outgoing": "Ausgehend",
      "duration": "Dauer",
      "contactsCount": "Gesamtzahl der Kontakte",
      "appointmentsCount": "Gesamtzahl der Termine",
      "formSubmissions": "Formulareinreichungen",
      "surveySubmissions": "Umfrageeinreichungen",
      "facebookFormSubmissions": "Facebook-Formulareinreichungen",
      "funnels": "Funnels",
      "websites": "Webseiten",
      "forms": "Formulare",
      "surveys": "Umfragen",
      "gbpMessages": "GBP-Nachrichten",
      "facebookMessages": "Facebook-Nachrichten",
      "instagramMessages": "Instagram-Nachrichten",
      "reviews": "Bewertungen",
      "positives": "Positive",
      "negatives": "Negative"
    },
    "timeOptions": {
      "00": "12:00 AM",
      "01": "1:00 AM",
      "02": "2:00 AM",
      "03": "3:00 AM",
      "04": "4:00 AM",
      "05": "5:00 AM",
      "06": "6:00 AM",
      "07": "7:00 AM",
      "08": "8:00 AM",
      "09": "9:00 AM",
      "10": "10:00 AM",
      "11": "11:00 AM",
      "12": "12:00 PM",
      "13": "1:00 PM",
      "14": "2:00 PM",
      "15": "3:00 PM",
      "16": "4:00 PM",
      "17": "5:00 PM",
      "18": "6:00 PM",
      "19": "7:00 PM",
      "20": "8:00 PM",
      "21": "9:00 PM",
      "22": "10:00 PM",
      "23": "11:00 PM"
    },
    "transferStatus": {
      "pending": "Anhängig",
      "processed": "Verarbeitet",
      "canceled": "Abgebrochen",
      "cancelled": "Abgebrochen",
      "completed": "Abgeschlossen",
      "rejected": "Abgelehnt",
      "failed": "Fehlgeschlagen",
      "payment_pending": "Zahlung steht aus"
    }
    }
